import { Component, h, Prop, Host } from "@stencil/core";
import { ShipmentStatusType } from "../track-response";

/**
 * @deprecated Use `ux-w-status` instead.
 * @slot - Content of the status.
 */
@Component({
    tag: "ux-w-track-status",
    styleUrl: "track-status.scss",
    shadow: false
})
export class TrackStatus {
    /** type of the status */
    @Prop() type: ShipmentStatusType;

    render() {
        const { type } = this;

        return (
            <Host class="ux-w-track-status">
                <ux-w-status type={`SHIPMENT_${type}`}>
                    <slot />
                </ux-w-status>
            </Host>
        );
    }
}
